import { UserFavorite } from './user-favorite';

export interface UserFavoriteAddUpdateResponseData {
  updatedUserFavoriteId: number;
  userFavorites: UserFavorite[];
}
